



















































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import collectorModelPo from "@/store/entities/devices/collectormodelpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class CreateCollector extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  collectorModelPo: collectorModelPo = new collectorModelPo();
  loading: boolean = false;
  async created() {
    this.areaTree();
    this.getItemDetail();
    this.collectorModelPo.isEnable = 1;
    this.collectorModelPo.rateNum = 0;
    await this.organizetiontree();
  }
  //组织数据
  async organizetiontree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizetionData = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 5;
      });
      info.forEach((ele) => {
        this.$data.potocolType.push({ label: ele.name, value: ele.id });
      });
      let ispl = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      ispl.forEach((ele) => {
        this.$data.ispType.push({ label: ele.name, value: ele.id });
      });
      let device = detaillist.filter((p) => {
        return p.itemId == 4;
      });
      device.forEach((ele) => {
        this.$data.deviceType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "collectormodel/create",
            data: this.collectorModelPo,
          }).then(() => {
            this.loading = false;
            this.collectorModelPo = new collectorModelPo();
          })
          .catch(() => {
            this.loading = false;
          });
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        type: "number",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Organization")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Name") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "number",
        message:
          this.L("Device") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      ispType: [],
      organizetionData: [],
      potocolType: [],
      deviceType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
